import { MapPin, Phone, Clock, MessageCircle, Navigation } from "lucide-react";
import { Reveal } from "@/lib/reveal";
import { CLINIC, whatsappLink, telLink } from "@/lib/site";
import { useLanguage } from "@/context/LanguageContext";

export const Contact = () => {
  const { t } = useLanguage();

  return (
    <section id="contact" data-testid="contact" className="py-24 md:py-32 bg-card border-t border-border">
      <div className="container-x grid lg:grid-cols-12 gap-10 lg:gap-16 items-start">
        <div className="lg:col-span-5">
          <Reveal className="overline font-bold tracking-[0.2em]">{t.contact.overline}</Reveal>
          <Reveal delay={0.05}>
            <h2 className="mt-6 text-3xl sm:text-4xl md:text-5xl font-extrabold tracking-tight text-foreground leading-[1.1]">
              {t.contact.title}
            </h2>
          </Reveal>

          <div className="mt-10 space-y-6">
            <Reveal delay={0.1} className="flex items-start gap-4">
              <span className="h-11 w-11 shrink-0 grid place-items-center rounded-sm border-2 border-border text-accent"><MapPin size={20} /></span>
              <div>
                <div className="text-xs sm:text-sm font-bold text-muted-foreground uppercase tracking-wider">{t.contact.addressLabel}</div>
                <div className="text-base sm:text-lg font-bold text-foreground mt-1">{CLINIC.address}</div>
              </div>
            </Reveal>
            <Reveal delay={0.15} className="flex items-start gap-4">
              <span className="h-11 w-11 shrink-0 grid place-items-center rounded-sm border-2 border-border text-accent"><Phone size={20} /></span>
              <div>
                <div className="text-xs sm:text-sm font-bold text-muted-foreground uppercase tracking-wider">{t.contact.phoneLabel}</div>
                <a href={telLink} className="text-base sm:text-lg text-accent font-extrabold mt-1 block link-underline w-fit">{CLINIC.phone}</a>
              </div>
            </Reveal>
            <Reveal delay={0.2} className="flex items-start gap-4">
              <span className="h-11 w-11 shrink-0 grid place-items-center rounded-sm border-2 border-border text-accent"><Clock size={20} /></span>
              <div>
                <div className="text-xs sm:text-sm font-bold text-muted-foreground uppercase tracking-wider">{t.contact.hoursLabel}</div>
                <div className="text-base sm:text-lg font-bold text-foreground mt-1">{t.contact.hoursVal}</div>
              </div>
            </Reveal>
          </div>

          <Reveal delay={0.25}>
            <div className="mt-10 flex flex-wrap gap-3.5">
              <a data-testid="contact-call" href={telLink} className="inline-flex items-center gap-2 h-12 px-6 rounded-sm bg-accent text-white text-base font-bold hover:bg-accent/90 shadow-md shadow-accent/25 transition-all">
                <Phone size={17} /> {t.contact.callBtn}
              </a>
              <a data-testid="contact-whatsapp" href={whatsappLink()} target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 h-12 px-6 rounded-sm bg-[#25D366] text-white text-base font-bold hover:bg-[#25D366]/90 shadow-md transition-all">
                <MessageCircle size={17} /> WhatsApp
              </a>
              <a data-testid="contact-maps" href={CLINIC.mapsUrl} target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 h-12 px-6 rounded-sm border-2 border-border bg-card text-foreground text-base font-bold hover:border-accent hover:text-accent transition-all">
                <Navigation size={17} /> {t.contact.mapsBtn}
              </a>
            </div>
          </Reveal>
        </div>

        <div className="lg:col-span-7 w-full">
          <Reveal delay={0.1}>
            <div className="aspect-[4/3] w-full overflow-hidden rounded-sm border border-border shadow-sm">
              <iframe
                title="FizioFit Center në hartë"
                data-testid="contact-map"
                src={CLINIC.mapsEmbed}
                className="h-full w-full grayscale-[0.15]"
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
              />
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
};
